export default theme => ({
  page_header_bar_buttons: {
    width: "100%",
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    "& > div": {
      padding: "0px !important",
    },
  },
});
